export const clearIcon = {
  src: 'https://nest-platform-assets.porter.in/clear_input_cross_grey_8d880447b1/clear_input_cross_grey_8d880447b1.svg',
  alt: 'clear',
} as const;
